import apiClient from '../../../services/apiClient';
import { buildRoleFlags } from '../utils/buildRoleFlags';

export type TrackActiveCampaignUserInput = {
  email: string;
  currentOrgId: string;
  currentOrgName: string;
  currentOrgRoles: string[];
  allRoles: string[];
  orgSub: boolean;
  curriculumSub: boolean;
  personalSub: boolean;
};

export function trackActiveCampaignUser({
  email,
  currentOrgId,
  currentOrgName,
  currentOrgRoles,
  allRoles,
  orgSub,
  curriculumSub,
  personalSub,
}: TrackActiveCampaignUserInput): Promise<unknown> {
  const payload = {
    currentOrgId,
    currentOrgName,
    orgSub,
    curriculumSub,
    personalSub,
    ...buildRoleFlags(allRoles, currentOrgRoles, 'camel'),
  };

  return apiClient.post('/trackUser', {
    email,
    payload,
  });
}
